module.exports = __webpack_public_path__ + "img/project-1.f4a13ca3.jpg";